import { render, staticRenderFns } from "./CalendarViewHeader.vue?vue&type=template&id=05ce52ff&"
import script from "./CalendarViewHeader.vue?vue&type=script&lang=js&"
export * from "./CalendarViewHeader.vue?vue&type=script&lang=js&"
import style0 from "./CalendarViewHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports